import React from 'react';
import ContactUsHero from './ContactUsHero/ContactUsHero';
import ContactForm from './ContactForm/ContactForm';
import ContactDetails from './ContactDetails/ContactDetails';
import Footer from '../../Components/Footer/Footer';
import SeoHelmet from '../../Components/SeoHelmet';
import { useTranslation } from 'react-i18next';

const ContactUs = () => {
  const { t , i18n} = useTranslation()

  return (
    <div>
        <SeoHelmet
        title="SunMed | Contact Us"
        description="SunMed: One Team with All Services under one roof — media production, social
        media, design, events, and web — all flowing from a unified creative
        vision.."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <ContactUsHero/>
      <ContactForm/>
      <ContactDetails/>
      <Footer/>
    </div>
  );
}

export default ContactUs;
